<script setup>
import TgButton from "@/abc-dsk/components/Button/TgButton.vue";

const props = defineProps({
  icon: {
    type: String,
    required: true
  },
  name: {
    type: String,
    required: true
  },
  description: {
    type: String,
    required: true
  },
  buttonDisabled: {
    type: Boolean,
    default: false
  },
  buttonLabel: {
    type: String,
    required: true
  }
});

const emit = defineEmits(["buttonClick"]);

const emitClick = () => {
  if (props.buttonDisabled) {
    return;
  }
  emit("buttonClick");
};
</script>

<template>
  <article
    class="exercise-item"
    :class="{ 'exercise-item--with-hover': !buttonDisabled }"
    @click="emitClick()"
  >
    <div class="exercise-item__icon-wrapper">
      <img class="exercise-item__icon" :src="icon" alt="" />
    </div>
    <h6 class="exercise-item__type">{{ props.name }}</h6>
    <p class="exercise-item__description">{{ props.description }}</p>
    <TgButton class="exercise-item__button" :disabled="buttonDisabled">
      {{ buttonLabel }}
    </TgButton>
  </article>
</template>

<style lang="less" scoped>
@import "@/abc-dsk/theming/index.less";

.exercise-item {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  padding: 40px 30px;
  transition: box-shadow 0.5s;
  border: 1px solid rgb(@theme-colors[@grey][50]);
  border-radius: 8px;
  text-align: center;

  & > * {
    flex-basis: 100%;
  }

  &--with-hover:hover {
    box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.2);
    cursor: pointer;
  }

  &:hover &__button:not(:disabled) {
    background-color: rgb(@theme-colors[@primary][110]);
  }

  &__type {
    margin: 20px 0 6px 0;
    font-size: 1.375rem;
    line-height: 1.625rem;
  }

  &__description {
    color: rgb(@theme-colors[@grey][base]);
  }

  &__button {
    align-self: flex-end;
    margin-top: 32px;
  }

  &__icon-wrapper {
    display: flex;
    align-items: center;
    align-self: flex-start;
    justify-content: center;
    max-width: 56px;
    height: 56px;
    max-height: 56px;
    border: 2px solid rgb(@theme-colors[@secondary][50]);
    border-radius: 50%;
    background-color: rgb(@theme-colors[@secondary][25]);
  }
}
</style>
